import { EPS_OPTIONS, FLOOD_CLAUSE_CODE } from '../../constants/domain-specific';
import {
  updateBuildingSI,
  updateConstruction,
  updateContentsSI,
  updateEPS,
  updateFlood,
  updateSprinkler,
  updateYearBuilt,
} from '../../slices/coverDetails';
import { AppDispatch } from '../../store';
import { Construction } from '../../types/cover';
import { Risk } from '../../types/policy';
import { RiskDetailBPKFireBusinessInterruption } from '../../types/risk';
import { clauseExists } from './clauseExists';

export const updateBuildingAndContentsAction = ({
  buildingAndContentsRisk,
  dispatch,
}: {
  buildingAndContentsRisk: Risk | undefined;
  dispatch: AppDispatch;
}) => {
  const { clauses } = buildingAndContentsRisk!;
  const buildingAndContentsRiskDetails = (
    buildingAndContentsRisk?.riskDetail as RiskDetailBPKFireBusinessInterruption | undefined
  )?.riskBPKFireBusinessInterruption;
  const { fire: buildingAndContentsDetails } = buildingAndContentsRiskDetails ?? {};
  const { buildingSI, contentsSI, construction, yearBuilt, sprinkler } =
    buildingAndContentsDetails!;

  dispatch(updateConstruction(construction as Construction));
  dispatch(updateYearBuilt(yearBuilt));
  dispatch(updateSprinkler(sprinkler === 'Y'));
  if (buildingSI || contentsSI) {
    dispatch(updateBuildingSI(buildingSI ?? 0));
    dispatch(updateContentsSI(contentsSI ?? 0));
  }
  dispatch(updateEPS(EPS_OPTIONS[0].value));

  if (clauses) {
    const floodClauseExists = clauseExists(clauses, FLOOD_CLAUSE_CODE);

    dispatch(updateFlood(floodClauseExists));
  } else {
    dispatch(updateFlood(false));
  }
};
